import { easeOutCubic } from '../helpers/helpers';

/* eslint-disable func-names */
/* eslint-disable no-undef */

const counters = () => {
  (function ($) {
    let inView = false;

    /**
     * Animate up to a specified number
     * @param {jqueryElement} $elem jquery element
     * @param {number} duration time in milliseconds
     * @param {number} t current value
     */
    const countUp = ($elem, duration = 2000, t = 0) => {
      console.log('COUNT UP FUNCTION');
      const target = Number($elem.attr('data-value'));
      const suffix = $elem.attr('data-suffix') || '';
      const prefix = $elem.attr('data-prefix') || '';
      const newValue = easeOutCubic(t, (duration / 1000) * 60, 0, target);

      $elem.text(Math.round(newValue));

      if (t < (duration / 1000) * 60) {
        window.requestAnimationFrame(countUp.bind(null, $elem, duration, t + 1));
      } else {
        // set the counter to its final value
        $elem.text(prefix + target + suffix);
      }
    };

    const checkInView = () => {
      if ((window.pageYOffset + window.innerHeight) > ($('.c-counters').offset().top + 90) && !inView) {
        console.log('IN VIEW');
        inView = true;
        $('.js-counter').each(function () {
          console.log('COUNT UP');
          countUp($(this));
        });
      }
    };

    if ($('.c-counters').length) {
      console.log('CHECK IN VIEW');
      checkInView();

      $(window).on('scroll', () => {
        console.log('SCROLL CHECK IN VIEW');
        checkInView();
      });
    }
  }(jQuery));
};

export default counters;
